import WildAppResource from "./WildAppResource";
import UserAppResource from './UserAppResource';
import Engine from "ss-js-engine/src/Engine";

class SellerAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'seller';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'sellers';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'email',
            'firstName',
            'lastName',
            'phone',
            'type',
            'userUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            user: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            user: 'user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            email: {
                type: 'string',
                email: true,
                presence: this.type == 'primary',
                length: {
                    maximum: 255,
                },
            },
            firstName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            lastName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            phone: {
                type: 'string',
                format: {
                    pattern: '^([0-9-. \(\)\+]*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 255,
                },
            },
        };
    }

    apiPaths () {
        return {
            ...super.apiPaths(),
            'sign': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/sign'),
            'inviteToSign': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/invite-to-sign'),
        }
    }

    async sign(data) {
        const url = this.apiPaths().sign.replace('{uuid}', this.uuid);

        return await Engine.post(url, {
            ...data,
        });
    }

    async inviteToSign(data) {
        const url = this.apiPaths().inviteToSign.replace('{uuid}', this.uuid);

        return await Engine.get(url, {
            ...data,
        });
    }
}

export default SellerAppResource;
